$(document).ready(function () {
	$(".at-title").click(function () {
	  $(this).toggleClass("active").next(".at-tab").slideToggle().parent().siblings().find(".at-tab").slideUp().prev().removeClass("active");
	});
});
